import { useCallback, useEffect, useState } from 'react'
import { GPOItem } from '../Gpo/types'
import { initialStateGpoDetails } from './constants'
import { getGpoDetailsList } from '../Gpo/api'
import { useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'
import Typography from '../../../components/Typography/Typography'
import { LABELS } from '../../../constants'
import { FieldWithLabel } from '../../../components/FieldWithLabel/FieldWithLabel'
import { formatAddress, fullFormatPhoneNumber } from '../../../helper/common'
import { LinkHighlighter } from '../../../components/LinkHighlighter/LinkHighlighter'

export const GpoDetails = () => {
  const currentUser = useSelector(getUser)

  const [details, setDetails] = useState<GPOItem>(initialStateGpoDetails)

  const getDetailsData = useCallback(async () => {
    if (!currentUser?.gpo) return
    const res = await getGpoDetailsList(currentUser?.gpo)
    setDetails(res?.data)
  }, [currentUser?.gpo])

  useEffect(() => {
    getDetailsData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="gpo-details-container">
      <div className="gpo-details-container__header row space-between align-center">
        <Typography.Headline5>{details?.name}</Typography.Headline5>
      </div>
      <div className="gpo-container__details__two-rows row mt-24 gap-24">
        <FieldWithLabel title={LABELS.WEBSITE}>
          {details?.website ? <LinkHighlighter text={details?.website} /> : '-'}
        </FieldWithLabel>
        <FieldWithLabel title={LABELS.PHONE_NUMBER}>
          {details?.phone_number
            ? fullFormatPhoneNumber(details.phone_number)
            : '-'}
        </FieldWithLabel>
      </div>
      <div className="row mt-16 gap-24">
        <FieldWithLabel
          title={LABELS.ADDRESS}
          className="full-width prs-details-general__left__contacts"
        >
          {details?.address ? formatAddress(details?.address) : '-'}
        </FieldWithLabel>
      </div>
    </div>
  )
}
